

angular
.module('inkfinder')
.factory('AppointmentData', function AppointmentData(
  $q,
  $http,
  $rootScope,
  $interval,
  ENDPOINT,
  moment,
  Appointment,
  Project,
  _
) {
  // Public variables
  AppointmentData.project = {};
  AppointmentData.appointments = {};
  AppointmentData.currentAppointment = {};

  // Public methods
  AppointmentData.matchAppointment = matchAppointment;
  AppointmentData.get = get;
  AppointmentData.refresh = refresh;
  AppointmentData.reset = reset;

  // Private variables
  let timer;
  let refreshing = false;
  let timestamp;
  let refreshInterval;

  /**
  * @name matchAppointment
  * @description Function to match the selected appoinment with one in the
  * appointments array for a specific project. This sets the selected
  * appointment on the view.
  * @param {number} appointmentId The appointment ID of the selected appointment.
  */
  function matchAppointment(appointmentId) {
    let selectedAppointment =
    _.find(AppointmentData.appointments, function(appointment) {
      if (appointment.id === Number(appointmentId)) {
        return true;
      }
    });
    AppointmentData.currentAppointment = selectedAppointment;
  }

  /**
   * @name refresh
   * @description Function to determine if we should get new data from the API.
   * @param {number} id The ID of the appointment to retrieve.
   * @return {promise} Promise Returns a promise so the resolve on the state
   * loads.
   */
  function refresh() {
    return $q(function(resolve, reject) {
      if (shouldRefresh()) {
        resolve(get(AppointmentData.currentAppointment.id));
      } else {
        resolve('Load cache');
      }
    });
  }

  /**
   * @name createAppointmentTimer
   * @description Function to create an internal timer and call
   * refreshAppointments() at a specific interval.
   * @param {number} id The ID of the appointment to retrieve.
   */
  function createAppointmentTimer() {
    timer = $interval(function() {
      refresh();
    }, 1000);
  }

  /**
   * @name shouldRefresh
   * @description Unknown
   * @return {boolean} boolean Returns true/false depending on refreshing and updated.
   */
  function shouldRefresh() {
    let result;
    let isNotRefreshing = !refreshing;
    let now = moment();
    let isTime = (!refreshInterval ||
    now.diff(refreshInterval, 'seconds') >= 5);
    result = isNotRefreshing && isTime;
    return result;
  }

  /**
   * @name get
   * @description Function to get a single appointment and project
   * @param {number} id The ID number of the appointment to retrieve
   * @return {empty} Empty Returns without sending data.
   */
  function get(id) {
    refreshing = true;
    let _timestamp = null;
    if (timestamp) {
      _timestamp = timestamp.format('X');
    }
    return Appointment.get(id, _timestamp)
    .then(function(appointment) {
      refreshing = false;
      refreshInterval = moment();
      return Project.get(appointment.project)
      .then(function(project) {
        timestamp = moment();
        if (!timer) {
          createAppointmentTimer();
        }
        AppointmentData.appointments = project.appointments;
        AppointmentData.project = project;
        if (!AppointmentData.currentAppointment.id || appointment.id ===
        AppointmentData.currentAppointment.id) {
          AppointmentData.currentAppointment = appointment;
        }
      });
    });
  }

  let deregister = $rootScope.$on('clear-data', reset);
  $rootScope.$on('$destroy', deregister);

  /**
   * @name reset
   * @description Reset variables
   */
  function reset() {
    AppointmentData.project = {};
    AppointmentData.appointments = {};
    AppointmentData.currentAppointment = {};
    $interval.cancel(timer);
    refreshing = false;
    refreshInterval = null;
    timestamp = null;
  }
  return AppointmentData;
});



// WEBPACK FOOTER //
// ./components/appointments/appointment/appointment.data.js